import { createContext, useContext, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { store } from "../redux/store";
import { performLogout } from "../utils/logout";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const isAuthenticated = store.getState().auth?.access_token;
    if (isAuthenticated) {
      setIsAuthenticated(true);
    }
  }, []);

  const login = (token) => {
    localStorage.setItem("token", token);
    setIsAuthenticated(true);
  };

  const logout = () => {
    // Keep local flag in sync for any components relying on context,
    // then delegate to the global logout helper so Redux + routes reset.
    setIsAuthenticated(false);
    performLogout();
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useAuth = () => useContext(AuthContext);
